import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const contractApi = createApi({
  reducerPath: 'contractApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/api/v1/contractor/contracts' }),
  tagTypes: ['Contract'],
  endpoints: (builder) => ({
    getContracts: builder.query({
      query: (searchParams = '') => `${searchParams}`
    }),
    getContract: builder.query({
      query: (id) => `/${id}`
    }),
    getParentsContracts: builder.query({
      query: (searchParams = '') => `/parents_index${searchParams}`
    }),
    getParentsSelectorContract: builder.query({
      query: (id) => ({
        url: `/parents_selector`,
        params: { id }
      }),
      transformResponse: (response) => response.contract // <-- esto es clave
    }),
    getParentsSelectorContracts: builder.query({
      query: (searchParams = '') => `/parents_selector${searchParams ? `${searchParams}` : ''}`,
      transformResponse: (response) => ({
        contracts: response.contracts,
        meta: response.meta
      })
    })
  })
})

const {
  useGetContractsQuery,
  useGetContractQuery,
  useGetParentsSelectorContractsQuery,
  useGetParentsSelectorContractQuery
} = contractApi

export {
  contractApi,
  useGetContractsQuery,
  useGetContractQuery,
  useGetParentsSelectorContractsQuery,
  useGetParentsSelectorContractQuery
}